import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Divider,
  Grid,
  Button,
  TextField,
  FormControlLabel,
  Checkbox,
  Typography,
  Tooltip
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import Skeleton from 'react-loading-skeleton';
import { ProductIntegrationOptions } from '../ProductIntegrationOptions';
import { getEventTypes } from 'store/schema/actions';

const useStyles = makeStyles(theme => ({
  root: {},
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%'
  },
  title: {
    display: 'flex',
    flexDirection: 'row',
    width: '95%'
  },
  closeIcon: {
    margin: '5px',
    cursor: 'pointer'
  },
  cardActions: {
    flexDirection: 'row-reverse'
  },
  inputGrid: {
    maxWidth: '40rem'
  }
}));

const Details = props => {
  const { className, staticContext, schema, next, showNav, ...rest } = props;
  const schemaDetails = useSelector(store => store.schema.currentDetails);
  const eventTypes = useSelector(store => store.schema.eventTypes);
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    isLoading,
    goNext,
    handleChange,
    onFocus,
    handleBlur,
    shouldShowError,
    getErrorMessage,
    updateCurrentErrorValidationSegment,
    closeSchema,
    toggleDefaultSchema
  } = schema;

  useEffect(() => {
    updateCurrentErrorValidationSegment('details');
    dispatch(getEventTypes());
  }, []);

  const SkeletonCardContent = () => (
    <Grid item md={6} xs={12}>
      <Typography
        display="block"
        style={{ fontSize: '2.2rem' }}
        className={classes.inputGrid}>
        <Skeleton />
      </Typography>
    </Grid>
  );

  return (
    <div className={classes.root}>
      <Card {...rest} className={clsx(classes.root, className)}>
        <form autoComplete="off">
          <div className={classes.headerContainer}>
            <div className={classes.title}>
              <CardHeader
                subheader="* indicates a required field"
                title="Schema Details"
                titleTypographyProps={{ variant: 'h1' }}
              />
            </div>
            <div className={classes.closeIcon}>
              <Tooltip title="Close" arrow>
                <CloseIcon
                  onClick={closeSchema}
                />
              </Tooltip>
            </div>
          </div>
          <Divider />
          <CardContent>
            <Grid container spacing={3}>
              <Grid item md={6} xs={12}>
                <Grid item xs={12} className={classes.inputGrid}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    required
                    margin="dense"
                    name="name"
                    label="Schema Name"
                    value={schemaDetails.name || ''}
                    onChange={handleChange}
                    onFocus={onFocus}
                    onBlur={handleBlur}
                    error={shouldShowError('name')}
                    helperText={getErrorMessage('name')}
                  />
                </Grid>
                {!eventTypes && <SkeletonCardContent />}
                {eventTypes && <ProductIntegrationOptions schema={schema} />}
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={schemaDetails.isDefaultSchema}
                        onChange={toggleDefaultSchema}
                        color="primary"
                        value="true"
                      />
                    }
                    label="Default Schema"
                  />
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
          <>
            <Divider />
            <CardActions className={classes.cardActions}>
              <Button
                color="primary"
                variant="contained"
                disabled={isLoading}
                link={next}
                onClick={goNext}>
                Next
              </Button>
            </CardActions>
          </>
        </form>
      </Card>
    </div>
  );
};

export default Details;
